module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Icon contains an <code>&lt;svg&gt;</code> that can display different icons in different\nforms.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<p><em>Add</em> icon:</p>\n<pre><code>&lt;Icon type=&quot;add&quot;&gt;Add&lt;/Icon&gt;\n</code></pre><p><em>Alert</em> icon with stroke:</p>\n<pre><code>&lt;Icon type=&quot;alert&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Icon/README.md
// module id = 356
// module chunks = 0